import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/slope-calculator',
  component: () => import('../../routes/SlopeCalculator.svelte'),
  card: {
    id: 'slope-calculator',
    title: 'Slope Calculator',
    description: 'Calculate the slope, angle, midpoint, and equation of a line between any two points. Find rise, run, and y-intercept instantly.',
    icon: 'show_chart',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/slope-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Slope Calculator – Find Slope Between Two Points Free',
    description: 'Free slope calculator to find slope, angle, midpoint, and line equation between any two points. Calculate rise, run, y-intercept, and see the line equation in slope-intercept form.',
  },
};

export default meta;
